/* Copyright 2013 - 2024 Waiterio LLC */
import { useContext } from '@monorepo/context/index.js'

export default function useSubdomain() {
  let [context] = useContext()
  return context.subdomain
}
